var render, staticRenderFns
import script from "./ticket-create.vue?vue&type=script&lang=js&"
export * from "./ticket-create.vue?vue&type=script&lang=js&"
import style0 from "./ticket-create.vue?vue&type=style&index=0&id=55e002f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e002f8",
  null
  
)

export default component.exports